const pl = {
  "front.faq.chat.title": "ZADAJ PYTANIE",
  "front.faq.chat.description": "natychmiastowe wsparcie dla gości restauracji",
  "front.faq.chat.welcome": "Tutaj możesz zadać pytanie bezpośrednio.",
  "front.faq.chat.placeholder": "wiadomość",
  "front.faq.chat.send": "wyślij",
  "front.faq.chat.unsupportedLanguage": "Przepraszamy, ten czat obsługuje obecnie tylko język angielski i niemiecki.",
  "front.faq.chat.fallback": "Dziękujemy za wiadomość. W tej chwili mogę odpowiadać tylko na najczęściej zadawane pytania. Skontaktuj się z nami bezpośrednio, aby uzyskać więcej informacji.",

  "front.faq.chat.answer.hours": "Jesteśmy otwarci codziennie od 10:00 do 22:00.",
  "front.faq.chat.answer.reservation": "Tak, możesz zarezerwować stolik bezpośrednio na naszej stronie internetowej lub telefonicznie.",
  "front.faq.chat.answer.groupReservation": "W przypadku rezerwacji grupowych skontaktuj się z nami bezpośrednio, abyśmy mogli znaleźć najlepszą opcję.",
  "front.faq.chat.answer.address": "Nasz adres to: Musterstraße 1, Berlin.",
  "front.faq.chat.answer.parking": "Tak, w pobliżu dostępne są miejsca parkingowe.",
  "front.faq.chat.answer.phone": "Możesz skontaktować się z nami pod numerem +49 000 000000.",
  "front.faq.chat.answer.payment": "Tak, można u nas płacić gotówką lub kartą.",
  "front.faq.chat.answer.menu": "Nasze aktualne menu znajdziesz na stronie internetowej. Jeśli masz pytania dotyczące konkretnych dań, chętnie pomożemy.",
  "front.faq.chat.answer.vegetarian": "Tak, oferujemy dania wegetariańskie.",
  "front.faq.chat.answer.vegan": "Tak, w naszym menu mamy również opcje wegańskie.",
  "front.faq.chat.answer.allergens": "Jeśli masz alergie lub nietolerancje, skontaktuj się z nami bezpośrednio. Chętnie udzielimy informacji o składnikach.",
  "front.faq.chat.answer.takeaway": "Tak, jedzenie można również zamówić na wynos.",
  "front.faq.chat.answer.delivery": "Obecnie przez stronę obsługujemy tylko rezerwacje i pytania.",
  "front.faq.chat.answer.terrace": "Tak, przy dobrej pogodzie można również usiąść na naszym tarasie.",
  "front.faq.chat.answer.pets": "Skontaktuj się z nami bezpośrednio, jeśli chcesz przyjść ze zwierzęciem.",
  "front.faq.chat.answer.children": "Tak, rodziny z dziećmi są u nas bardzo mile widziane.",
  "front.faq.chat.answer.wifi": "Tak, dla naszych gości dostępne jest Wi-Fi.",

  "front.acquaintance.callback.placeholder": "Twój numer telefonu",
  "front.acquaintance.callback.send": "Wyślij",
  "front.acquaintance.callback.sending": "Wysyłanie...",
  "front.acquaintance.callback.invalidPhone": "Wpisz prawidłowy numer telefonu.",
  "front.acquaintance.callback.success": "Zgłoszenie wysłane. Wkrótce się z Tobą skontaktuję.",
  "front.acquaintance.callback.error": "Błąd podczas wysyłania zgłoszenia. Spróbuj ponownie.",

  "front.landingSeo.links.digitalMenu": "Cyfrowe menu dla restauracji",
  "front.landingSeo.links.qrMenu": "Menu z kodem QR dla restauracji",
  "front.landingSeo.links.multilingualMenu": "Wielojęzyczne menu dla restauracji",
  "front.landingSeo.links.reservation": "Rezerwacja stolików online dla restauracji",
  "front.landingSeo.links.freeDigitalMenu": "Przetestuj bezpłatne menu cyfrowe",
  "front.landingSeo.links.changeMenuOnline": "Zmieniaj menu online",
  
  "menu.title": "Menu",
  "menu.promo": "Oferty specjalne",
  "menu.empty.categoryTitle": "Uzupełnij nazwę kategorii",
  "menu.empty.itemTitle": "Uzupełnij nazwę produktu",
  "menu.empty.itemDescription": "Uzupełnij opis produktu",
  "cart.add": "Dodaj do koszyka",
  "cart.cancel": "Anuluj",
  "section.video": "Prezentacja wideo",
  "section.tables": "REZERWACJA STOLIKA ONLINE",
  "section.table": "WYBIERZ STÓŁ",
  "section.menu": "Menu restauracji",
  "section.faq": "FAQ",
  "section.contact": "Kontakt",
  "promo.buy": "Kup",

  "front.tenant.resolving": "Wykrywanie restauracji na podstawie subdomeny…",
  "front.tenant.notFound": "Nie znaleziono klienta dla tej subdomeny",
  "front.tenant.resolveError": "Nie udało się ustalić klienta",
  "front.menu.loading": "Ładowanie…",
  "front.menu.loadError": "Nie udało się załadować menu",
  "front.menu.addtocart": "Koszyk",
  "front.menu.cancel": "Anuluj",
  "front.Number.servings": "Liczba porcji",

  "orbit.menu": "MENU",
  "orbit.shef": "REZERWACJA",
  "orbit.video": "WIDEO",
  "orbit.faq": "PYTANIA",
  "orbit.interior": "WNĘTRZE",
  "orbit.footer": "MEDIA SPOŁECZNOŚCIOWE",

  "shef.title.line1": "ONLINE",
  "shef.title.line2": "REZERWACJA",
  "shef.banner.label": "Wybierz",
  "shef.banner.main": "swój stolik",
  "shef.reserved": "ZAREZERWOWANO",

  "video.title": "TAK GOTUJEMY — UCZCIWIE I SMACZNIE",
  "video.add": "Dodaj wideo",
  "add.video.but": "Dodaj",

  "interior.title": "NASZE WNĘTRZE",

  "footer.kontact": "KONTAKTY",

  "telegram.title": "Aby skonfigurować powiadomienia o zamówieniach w Telegramie, musisz:",
  "telegram.title.first": "1. Uzyskać BOT_TOKEN",
  "telegram.text.first": "Aby uzyskać BOT_TOKEN, znajdź i uruchom bota @BotFather w Telegramie, wyślij komendę /newbot, postępuj zgodnie z instrukcjami, aby utworzyć unikalną nazwę bota i nazwę użytkownika, a następnie skopiuj token API, który @BotFather wyśle w odpowiedzi.",
  "telegram.title.two": "2. Uzyskać CHAT_ID",
  "telegram.text.two": "Aby uzyskać CHAT_ID, znajdź i uruchom bota @UserInfoBot w Telegramie, wyślij komendę /start, a następnie skopiuj ID otrzymane w wiadomości zwrotnej.",

  "cart.title": "TWÓJ KOSZYK",
  "cart.header.aria": "Twój koszyk",
  "cart.toggle.expand": "Rozwiń koszyk",
  "cart.toggle.collapse": "Zwiń koszyk",
  "cart.total.label": "Razem",
  "cart.total.products": "produkty",
  "cart.button.primary": "zamów",
  "cart.button.back": "wstecz",
  "cart.button.waiter": "KELNER",

  "cart.mode.takeaway": "na wynos",
  "cart.mode.tableTime": "Czas i stolik",
  "cart.mode.tableTime.disabled": "brak wolnych stolików",
  "cart.mode.tableTime.tooltip": "Czas i stolik",
  "cart.mode.tableTime.tooltipNoFree": "brak wolnych stolików",
  "cart.mode.inHouse": "na miejscu",

  "cart.bookingFlow.title": "REZERWACJA. NUMER STOLIKA",
  "cart.deposit.itemTitle": "Rezerwacja stolika (depozyt)",
  "cart.deposit.lineTitle": "Depozyt",
  "cart.deposit.badge": "Depozyt {amount}€",

  "cart.table.msg.tempChosen": "Stolik {table} wybrany tymczasowo ✓",
  "cart.table.msg.noFree": "Niestety nie ma wolnych stolików",
  "cart.table.msg.chooseOrDefault": "Wybierz stolik albo użyj domyślnego wyboru.",

  "cart.table.select.reserved": "ZAREZERWOWANO",
  "cart.table.select.pick": "WYBIERZ",
  "cart.table.select.any": "DOWOLNY",

  "cart.inHouse.title": "WYBIERZ NUMER STOLIKA",
  "cart.inHouse.select.placeholder": "Wybierz stolik",
  "cart.inHouse.select.option": "Stolik #{n}",

  "cart.checkout.back": "Wstecz",
  "cart.payment.preparing": "Przygotowywanie płatności…",
  "cart.loading": "Ładowanie…",

  "mockCheckout.title.paymentMethod": "METODA PŁATNOŚCI",
  "mockCheckout.method.card": "Karta bankowa",
  "mockCheckout.method.paypal": "PayPal",
  "mockCheckout.method.gpay": "Google Pay",
  "mockCheckout.cardForm.title": "WPROWADŹ DANE KARTY",
  "mockCheckout.cardForm.numberLabel": "NUMER KARTY",

  "mockCheckout.error.invalidCardNumber": "Nieprawidłowy numer karty",
  "mockCheckout.error.enter16Digits": "Wprowadź 16 cyfr",
  "mockCheckout.error.expiryFormat": "Format MM/RR",
  "mockCheckout.error.expiryMonthRange": "Miesiąc 01–12",
  "mockCheckout.error.cardExpired": "Karta wygasła",
  "mockCheckout.error.cvc3Digits": "3 cyfry",

  "mockCheckout.error.sendTelegram": "Błąd wysyłania do Telegrama",
  "mockCheckout.error.generic": "Coś poszło nie tak",

  "mockCheckout.reserve.clientNotFound": "Klient nie znaleziony",
  "mockCheckout.reserve.tablesNotFound": "Ten klient nie ma sekcji stolików",
  "mockCheckout.reserve.tableNotFound": "Stolik nie znaleziony",
  "mockCheckout.reserve.alreadyReserved": "Ten stolik właśnie został zajęty. Wybierz inny.",
  "mockCheckout.reserve.noFreeTables": "Obecnie nie ma wolnych stolików",
  "mockCheckout.reserve.tableNotSelected": "Wybierz stolik",
  "mockCheckout.reserve.genericError": "Błąd rezerwacji",

  "mockCheckout.button.back": "wstecz",
  "mockCheckout.button.pay": "ZAPŁAĆ",
  "mockCheckout.button.sending": "…wysyłanie",
  "mockCheckout.button.paid": "...",
  "mockCheckout.button.payInvalidTitle": "Sprawdź dane karty",

  "admin.booking.lead.title": "MINIMALNY CZAS REZERWACJI",
  "admin.booking.lead.note": "Dotyczy tylko rezerwacji gości w trybie „stolik i czas”. Krok wynosi 30 minut.",

  "dateTimeStep.select.time": "WYBIERZ GODZINĘ",

  "admin.title": "PANEL ADMINA",
  "admin.loading": "Ładowanie…",
  "admin.nav.delete": "Usuń",
  "admin.nav.back": "Wstecz",
  "admin.nav.next": "DALEJ",
  "admin.nav.confirm": "ZAPISZ",
  "admin.nav.confirm.now": "zapisywanie ...",
  "admin.booking.settings": "Ustawienia rezerwacji",
  "admin.booking.deposit": "KWOTA DEPOZYTU",
  "admin.booking.deposit.note": "Depozyt jest pobierany, gdy gość rezerwuje tylko stolik",

  "admin.hub.editmenu": "EDYCJA MENU",
  "admin.hub.qr": "KOD QR",
  "admin.hub.prices": "TWÓJ PLAN",
  "admin.hub.settings": "USTAWIENIA",

  "admin.panel.editmenu": "Edytuj menu",
  "admin.validation.required": "Pole wymagane",
  "admin.panel.add": "Dodaj pozycję",
  "admin.panel.menu": "Edytuj listę menu",
  "admin.panel.telegram": "Telegram",
  "admin.panel.table": "ZARZĄDZANIE STOLIKAMI",
  "admin.set.table": "Sale / stoliki",
  "admin.set.logo": "Logo i tła",
  "admin.logo.successfully.applied": "Logo zostało pomyślnie zastosowane",
  "admin.logo.download.error": "Błąd pobierania",
  "admin.settings.number.rooms": "Liczba sal",
  "admin.settings.room": "Sala",

  "admin.qr.title": "Kod QR dla gości",
  "admin.qr.alt": "QR dla restauracji",
  "admin.qr.copy": "kopiuj link",
  "admin.qr.copied": "✓ skopiowano",
  "admin.qr.note": "Goście mogą zeskanować ten kod, aby natychmiast otworzyć Twoją stronę.",

  "admin.link.notfound": "Link nie znaleziony",
  "admin.table.info": "Zarządzanie stolikami jest dostępne na tej stronie. Status zmienia się przez naciśnięcie stolika.",
  "admin.prices.temp": "Ceny są tymczasowo niedostępne.",
  "admin.forgot.password": "Nie pamiętasz hasła?",
  "admin.success.description": "Kliknij OK i dodaj kolejny produkt",

  "order.success": "Pozycja dodana do koszyka!",
  "order.error": "Ta pozycja jest już w koszyku",

  "popap.product.removal": "Usuwanie produktu",
  "popap.category.removal": "Usuwanie kategorii",
  "popap.want.delete.product": "Czy na pewno chcesz usunąć produkt",
  "popap.want.delete.category": "Czy na pewno chcesz usunąć kategorię?",

  "admin.settings.guestLang": "Domyślny język dla gości",
  "admin.settings.adminLang": "Domyślny język dla admina",
  "admin.settings.noteGuest": "Ten język zostanie ustawiony jako domyślny, gdy goście otworzą stronę.",
  "admin.settings.noteAdmin": "Ten język zostanie ustawiony jako domyślny w panelu admina.",
  "admin.language": "Język",
  "admin.settings.logo": "Logo lokalu",
  "admin.settings.logo.text": "Prześlij swoje logo (PNG/JPG/WEBP/SVG, do 2 MB). Następnie kliknij „Zapisz”; aktualne logo zostanie zastąpione nowym.",
  "admin.settings.backtable": "Obraz tła na ekranie wyboru stolików",
  "admin.settings.backhome": "Obraz tła ekranu głównego",
  "admin.settings.backtable.text": "Prześlij obraz tła (SVG/PNG/JPG/WEBP). Następnie kliknij „Zapisz”; aktualne tło zostanie zastąpione nowym.",
  "admin.settings.language.visitors": "Główny język dla gości lokalu",
  "admin.settings.language.visitors.text": "Ten język zostanie ustawiony jako główny, gdy goście otworzą stronę",
  "admin.settings.language.admin": "Główny język Twojego panelu admina",
  "admin.settings.language.admin.text": "Ten język zostanie ustawiony jako domyślny po otwarciu panelu admina",
  "admin.settings.gallery": "Galeria",
  "admin.settings.social": "Sieci społecznościowe",
  "admin.settings.number.tables": "Liczba stolików",
  "admin.settings.how.many.tables": "Ile stolików jest w lokalu?",
  "admin.settings.tables.test": "Zapisz liczbę stolików i wróć do poprzedniej zakładki, aby skonfigurować każdy stolik osobno.",
  "admin.settings.upload.panoramic": "Prześlij panoramiczne zdjęcie sali swojego lokalu",
  "admin.settings.table": "Stolik",
  "admin.settings.table.not.found": "Stolik nie znaleziony",
  "admin.settings.contact.details": "Dane kontaktowe",
  "admin.contacts.company": "Nazwa firmy",
  "admin.contacts.address": "Adres",
  "admin.contacts.phone": "Numer telefonu",
  "admin.socials.title": "Media społecznościowe",
  "admin.settings.rooms.hint": "Podaj liczbę sal w lokalu",

  "admin.settable.title": "Krok 3. Numeracja stolików",
  "admin.settable.text1": "Każda etykieta ma numer; umieść etykiety zgodnie z numerami stolików.",
  "admin.settable.text2": "Użyj przełącznika, aby zmienić rozmiar etykiety.",
  "admin.settable.text3": "Zapisz dane bieżącego stolika i kliknij odpowiednią ikonę, aby przełączać się między stolikami.",
  "admin.setqr.title": "Twoje kody QR",
  "admin.setqr.text1": "na tej stronie zapisywane są Twoje wiadomości, menu i kody QR",
  "admin.setqr.text2": "po zakupie planu BASIC automatycznie zostanie wygenerowany kod QR oraz link do Twojej subdomeny (np. example.best-place.club)",
  "admin.setqr.text3": "możesz otworzyć link, skopiować go, a także zapisać kod QR jako obraz na swoim urządzeniu",
  "admin.setpanorama.title": "Krok 2. Zdjęcie panoramiczne",
  "admin.setpanorama.text1": "Dodaj zdjęcie panoramiczne. Zaleca się używanie lekkich plików, np. w formacie WEBP.",
  "admin.setpanorama.text2": "Jeśli obraz został pomyślnie przesłany, zobaczysz go w podglądzie poniżej.",
  "admin.setnumber.title": "Krok 1. Liczba stolików",
  "admin.setnumber.text1": "Wybierz liczbę stolików w swoim lokalu",
  "admin.setnumber.text2": "Zaleca się rozpoczęcie konfiguracji od jednego lub dwóch stolików, a następnie zwiększenie ich liczby.",

  "admin.current.logo": "Aktualne logo",
  "admin.add.photo": "tutaj możesz dodać plik",
  "admin.add.file": "formaty plików do przesłania: .xlsx, .xls, .csv",
  "admin.add.file.but": "Dodaj plik",
  "admin.import.format": "Format kolumn: Kategoria / Tytuł / Opis / Cena",
  "admin.import.follow": "zachowaj podany format kolumn i przygotuj plik w odpowiednim formacie",
  "admin.import.BeСareful": "Uwaga: podczas importu poprzednie dane zostaną utracone",
  "admin.add.photo.but": "Dodaj zdjęcie",
  "admin.add.photo.set": "Dodaj zdjęcie",

  "admin.wizard.step1": "Wybierz kategorię",
  "admin.wizard.step2": "Nazwa i cena",
  "admin.wizard.step3": "Opis i zdjęcie",
  "admin.wizard.ready": "Gotowe",
  "admin.wizard.defaultTitle": "Dodaj produkt",
  "admin.wizard.step1.desc": "Krok 1. Wybierz istniejącą kategorię albo utwórz nową",
  "admin.wizard.step2.desc": "Krok 2. Wybierz nazwę produktu i ustaw cenę",
  "admin.wizard.step3.desc": "Krok 3. Napisz opis produktu, dodaj zdjęcie i kliknij zapisz",
  "admin.wizard.step1.desc.short": "Krok 1. Wybierz istniejącą lub nową kategorię",
  "admin.wizard.step2.desc.short": "Krok 2. Dodaj nazwę i cenę produktu",
  "admin.wizard.step3.desc.short": "Krok 3. Opisz produkt i dodaj zdjęcie",

  "admin.wizard.tab.existing": "Istniejąca",
  "admin.wizard.tab.new": "Nowa",
  "admin.wizard.cat.loading": "Ładowanie…",
  "admin.wizard.cat.empty": "Nie ma jeszcze kategorii. Przełącz na „Nowa” i utwórz pierwszą.",

  "admin.form.categoryKeyDe": "Kategoria (KEY/PL)",
  "admin.form.categoryEn": "Kategoria (EN)",
  "admin.form.titleMain": "Nazwa produktu",
  "admin.form.descMain": "Opis produktu",
  "admin.validation.req": "Wprowadź nazwę produktu",
  "admin.form.titleDe": "Tytuł (DE)",
  "admin.form.titleEn": "Tytuł (EN)",
  "admin.form.nameDe": "Nazwa (DE)",
  "admin.form.nameEn": "Nazwa (EN)",
  "admin.form.price": "Cena",
  "admin.form.descDe": "Opis (DE)",
  "admin.form.descEn": "Opis (EN)",

  "admin.toast.productAdded": "Produkt został pomyślnie dodany",
  "admin.tooltip.fixFormErrors": "Popraw błędy w formularzu",

  "admin.validation.firstCharNotDigit": "Pierwszy znak nie może być cyfrą.",
  "admin.validation.maxChars": "skróć nazwę produktu",
  "admin.validation.chooseCategory": "Wybierz kategorię.",
  "admin.validation.chooseCategoryFromList": "Wybierz kategorię z listy.",
  "admin.validation.enterCategoryName": "Wprowadź nazwę kategorii.",
  "admin.validation.enterProductName": "Wprowadź nazwę produktu.",
  "admin.validation.priceFormat": "Nieprawidłowy format ceny (np. 12.50)",
  "admin.validation.enterDescription": "Wprowadź opis.",
  "admin.tarif.apply": "zastosuj",
  "admin.menu.creating": "Utwórz menu",
  "admin.choose.template": "Krok 1: Wybierz szablon",
  "admin.choose.template2": "Krok 2: Sprawdź pozycje produktów",
  "admin.choose.atyle": "Wybierz styl menu. Możesz go później zmienić",

  "admin.error.tenantNotFound": "Nie znaleziono klienta dla tej subdomeny.",
  "admin.error.resolveClient": "Nie udało się ustalić klienta.",
  "admin.error.menuLoad": "Nie udało się załadować menu.",
  "admin.error.saveLang": "Nie udało się zapisać języka.",
  "admin.error.clientNotFound": "Klient nie znaleziony na serwerze",
  "admin.error.arrNotFound": "Tablica danych nie została znaleziona dla tego klienta",

  "tpl.premium.title": "Premium",
  "tpl.classic.title": "Klasyczny",
  "tpl.dark.title": "Ciemny",
  "tpl.minimal.title": "Minimalistyczny",
  "tpl.premium.desc": "Bestseller",
  "tpl.classic.desc": "jasny",
  "tpl.dark.desc": "ciemny",
  "tpl.minimal.desc": "minimalistyczny",

  "tp2.position.total": "Masz teraz:",
  "tp2.position.punkte": "Pozycje menu",
  "tp2.position.template": "Szablon",

  "tp3.qr.link": "Kod QR i link do menu",
  "tp3.step3.title": "Krok 3: Podgląd / Publikacja",
  "admin.tp.progres.publication": "Publikacja",
  "admin.tp.progres.positionen": "Pozycja",

  "tp4.link.copy": "KOPIUJ",
  "tp4.link.copy.ok": "✓ SKOPIOWANO",

  "admin.tp.publish": "Publikuj",
  "admin.tp.posting": "publikowanie ...",

  "admin.import.from.excel": "Importuj menu z Excela",

  "popap.successful.payment": "Płatność zakończona sukcesem",

  "landing.title": "Cyfrowe rozwiązania dla restauracji",
  "landing.title.login": "Zaloguj się",
  "landing.text": "Uruchom stronę swojej restauracji w kilka minut!",
  "landing.try.now": "wypróbuj za darmo",
  "landing.title.to": "Dla kogo jest nasza usługa?",
  "landing.title.answer": "Przede wszystkim będzie przydatna dla właścicieli lokali, których celem jest przyciąganie nowych klientów i utrzymanie obecnych",
  "landing.content.title.first": "Menu online z kodem QR",
  "landing.content.first": "Twoi goście mogą liczyć na aktualne menu i ceny, skanując po prostu kod QR. Oferty specjalne zwiększą lojalność gości wobec Twojego produktu",
  "landing.content.title.second": "Rezerwacje stolików online",
  "landing.content.second": "Oferujemy gościom wizualną rezerwację stolika online z dodatkowymi zdjęciami panoramicznymi. W razie potrzeby mogą przełączać się między sąsiednimi strefami",
  "landing.content.title.third": "Klimatyczne treści",
  "landing.content.third": "Potencjalni goście mogą obejrzeć różne treści: zdjęcia wnętrza, filmy z przygotowywania najlepszych dań oraz panoramiczny widok sali.",
  "landing.content.title.four": "Zwiększ średni rachunek",
  "landing.content.four": "Oferuj gościom wydarzenia, takie jak bankiety, urodziny lub specjalne oferty na większe albo codzienne zamówienia",
  "landing.request": "Skontaktujemy się z Tobą wkrótce",
  "callback.invalidPhone": "Wprowadź prawidłowy numer telefonu",
  "landing.enter.number": "TWÓJ NUMER",
  "callback.submitError": "Nie udało się wysłać numeru. Spróbuj ponownie",
  "landing.tariff.advance": "Ostrzeżenie",
  "landing.tariff.advance.desc": "W ramach wybranego planu możesz bezpłatnie wypełnić aplikację treścią",
  "landing.tariff.one-time-not-included": "Indywidualna wycena. W prawym rogu ekranu znajduje się przycisk kontaktowy. Zostaw swój numer, a skontaktujemy się z Tobą",
  "landing.tariff.one-time-services": "Usługi jednorazowe",
  "landing.tariff.logo-creation": "Tworzenie logo",
  "landing.tariff.selling-images": "Sprzedaż zdjęć produktów",
  "landing.tariff.panorama-creation": "Tworzenie panoramy",

  "demo.video.unsupported": "Twoja przeglądarka nie obsługuje wideo",
  "demo.title.after": "przegląd usługi",
  "demo.title.accent": "krótki",
  "demo.title.before": "Krótki",
  "demo.title.total": "o usłudze",
  "demo.title": "Przegląd wideo",

  "landing.free.first": "Menu online za pomocą kodu QR dostępne, rezultat w kilka minut.",
  "landing.free.second": "Możliwość edycji menu na bieżącą datę",
  "landing.free.third": "Dostęp do kreatora menu",
  "landing.basic.first": "Pełna strona URL z dostępem do menu przez kod QR",
  "landing.basic.second": "Zamówienia online dla Twoich gości",
  "landing.basic.third": "Rezerwacje stolików online, zdjęcia panoramiczne sali, klikalne stoliki oraz podgląd w czasie rzeczywistym stolików zarezerwowanych i dostępnych",
  "landing.basic.fourth": "Menu z tłumaczeniem na dowolny język",
  "landing.pro.first": "Funkcje pozwalające zarządzać ofertami cenowymi, tworzyć banery i strategie marketingowe",
  "landing.pro.second": "Możliwość zarządzania systemem lojalnościowym gości i wpływania na końcowy wynik opinii w Google",
  "landing.pro.third": "",
  "landing.title.free": "Bezpłatnie przez 14 dni",
  "landing.registerTitle": "Rejestracja",
  "landing.tariff.selection": "Wybór planu",
  "landing.tariff.subdomain": "Rejestracja subdomeny",
  "landing.tariff": " / miesięcznie",
  "landing.your.tariff": "twój plan",
  "landing.your.example": "na przykład",
  "landing.Subdomain.selection": "Wybór subdomeny",
  "landing.password": "hasło",
  "landing.tariff.free": "DARMOWY",
  "landing.tariff.free-description": "aby zapoznać się z usługą",
  "landing.tariff.basic": "BASIC",
  "landing.tariff.basic-description": "podstawowe funkcje na start",
  "landing.tariff.pro": "PRO",
  "landing.tariff.pro-description": "Dla zaawansowanych użytkowników",
  "landing.tariff.selected": "✓ wybrano",
  "landing.legal.text.start": "Akceptuję",
  "footer.legal.terms": "Warunki",
  "landing.legal.text.mid": "oraz",
  "landing.tariff.optional": "Usługi jednorazowe",
  "landing.tariff.one-time-note": "Zobacz stawki za tworzenie wysokiej jakości, sprzedażowych obrazów",
  "landing.tariff.pro-locked-desc": "Ten plan nie jest jeszcze dostępny",
  "landing.tariff.in-development": "W przygotowaniu",
  "landing.tariff.free-one-time-desc": "do wypełnienia publikacji wysokiej jakości obrazami",

  "footer.legal.privacy": "Prywatność",
  "footer.legal.privacy.and": "polityka",
  "footer.about": "Platforma dla restauracji: menu, rezerwacje stolików, zamówienia i panel admina.",

  "server.common.unknown": "Nieznany błąd.",
  "server.common.serverError": "Wewnętrzny błąd serwera.",
  "server.common.networkError": "Błąd sieci. Spróbuj ponownie.",
  "server.common.clientIdMissing": "Błąd: brakuje clientId.",

  "server.login.required": "E-mail i hasło są wymagane.",
  "server.login.invalidCredentials": "Nieprawidłowy e-mail lub hasło.",
  "server.login.signupIncomplete": "Konto nie jest jeszcze aktywne. Dokończ rejestrację.",
  "server.login.success": "Logowanie zakończone sukcesem!",

  "server.register.required": "E-mail i hasło są wymagane.",
  "server.register.emailExistsActive": "Użytkownik z tym adresem e-mail już istnieje. Użyj logowania.",
  "server.register.resume": "Kontynuacja rejestracji.",
  "server.register.success": "Rejestracja zakończona sukcesem!",

  "server.signupComplete.success": "Aktywacja zakończona sukcesem!",
  "server.signupComplete.error": "Aktywacja nie powiodła się.",

  "server.subdomain.required": "clientId i subdomena są wymagane.",
  "server.subdomain.planInvalid": "Nieprawidłowy plan. Dozwolone: free | basic | pro.",
  "server.subdomain.invalid": "Nieprawidłowa subdomena (a-z, 0-9, '-', 3–30, bez '-' na początku/końcu).",
  "server.subdomain.reserved": "Ta subdomena jest zarezerwowana.",
  "server.subdomain.taken": "Ta subdomena jest już zajęta.",
  "server.subdomain.userNotFound": "Użytkownik nie znaleziony.",
  "server.subdomain.success": "Subdomena zarejestrowana. Przekierowanie…",
  "server.subdomain.error": "Rejestracja subdomeny nie powiodła się.",

  "landing.loginTitle": "Login",
  "landing.btn.login": "Login",
  "landing.btn.register": "Rejestracja",
  "landing.btn.enter": "Wejdź",
  "landing.loggingIn": "Logowanie…",
  "landing.registering": "Rejestracja…",
  "landing.activating": "Aktywacja…",
  "landing.subdomain.registering": "Rejestrowanie subdomeny…",
  "landing.redirecting": "Przekierowanie…",
  "landing.legal.required": "Zaakceptuj warunki i politykę prywatności.",

  "landing.subdomain.err.empty": "Wprowadź subdomenę.",
  "landing.subdomain.err.chars": "Tylko litery, cyfry i '-', 3–30 znaków.",
  "landing.subdomain.err.hyphen": "Subdomena nie może zaczynać się ani kończyć znakiem '-'.",
  "landing.subdomain.err.reserved": "Ta subdomena jest zarezerwowana.",

  "admin.menuLanguages.title": "Języki menu",
  "admin.menuLanguages.default": "Język, który jako pierwszy zobaczy osoba odwiedzająca Twoją placówkę (domyślnie)",
  "admin.menuLanguages.hint": "Wybierz języki, które będą dodatkowo używane",
  "common.success": "Sukces",
  "admin.import.activeLangs": "Aktywne języki menu",
  "admin.import.sourceLangHint": "Excel będzie wyświetlany tylko w wybranym języku. Pola w pozostałych aktywnych językach pozostaną puste",
  "admin.import.sourceLang": "Określ język, w którym napisany jest plik Excel",
  "admin.import.mainLang": "główny",
  "booking.date.today": "Dziś",
  "booking.date.tomorrow": "Jutro",
  "booking.room": "Sala",

  "front.faq.chat.answer.greeting": "Witaj! Mogę pomóc w rezerwacji, menu, adresie, godzinach otwarcia i innych pytaniach.",
"front.faq.chat.answer.howAreYou": "Dziękuję, wszystko dobrze! W czym mogę pomóc w sprawie restauracji?",
"front.faq.chat.answer.thanks": "Proszę bardzo! Napisz, jeśli masz jeszcze jakieś pytania.",
"front.faq.chat.answer.goodbye": "Do widzenia! Będzie nam miło Cię gościć.",
"front.faq.chat.answer.whoAreYou": "Jestem cyfrowym asystentem restauracji. Pomagam gościom w najczęstszych pytaniach.",
"front.faq.chat.answer.help": "Mogę pomóc w rezerwacji, menu, adresie, numerze telefonu, płatnościach, alergenach, dostawie i innych pytaniach.",
"front.faq.chat.answer.recommendation": "Polecam zajrzeć do menu — znajdziesz tam aktualne dania i wybierzesz to, co najbardziej Ci odpowiada.",
"front.faq.chat.answer.compliment": "Bardzo dziękujemy! Miło nam to słyszeć.",

"checkout.button.send": "WYŚLIJ",
"checkout.button.sending": "Wysyłanie ...",
"checkout.button.sent": "Wysłano",
"checkout.title.order": "ZAMÓWIENIE",
"checkout.phone.title": "Wpisz swój numer telefonu",
"checkout.phone.label": "Numer telefonu",

"footer.workingHours": "Godziny pracy",

"admin.offline.title": "Brak połączenia z Internetem",
"admin.offline.text": "Sprawdź połączenie z Internetem. Po przywróceniu połączenia będzie można automatycznie kontynuować pracę.",
"admin.offline.status": "Oczekiwanie na połączenie…",


};

export default pl;